import styled from "styled-components";
import {radii} from "theme/tokens";

/**
 * Styles for the anonymous unsubscribe page. Colors come from `theme.tokens` only — this page is
 * reached from an email by people who have never seen the app, so it must look right in both modes
 * without any persisted preference.
 */

export const Root = styled.main`
	align-items: center;
	display: flex;
	justify-content: center;
	min-height: 60vh;
	padding: 48px 16px;
`;

export const Card = styled.section`
	background: ${({theme}) => theme.tokens.card};
	border: 1px solid ${({theme}) => theme.tokens.cardBorder};
	border-radius: ${radii.card};
	box-shadow: ${({theme}) => theme.tokens.shadowCard};
	max-width: 520px;
	padding: 32px;
	width: 100%;
`;

export const Heading = styled.h1`
	color: ${({theme}) => theme.tokens.ink};
	font-size: 24px;
	line-height: 1.25;
	margin: 0 0 12px;
`;

export const Body = styled.p`
	color: ${({theme}) => theme.tokens.ink2};
	font-size: 15px;
	line-height: 1.6;
	margin: 0 0 12px;
`;

export const Actions = styled.div`
	display: flex;
	gap: 12px;
	margin-top: 24px;
`;

export const ConfirmButton = styled.button`
	background: ${({theme}) => theme.tokens.blue};
	border: none;
	border-radius: ${radii.control};
	color: ${({theme}) => theme.tokens.blueInk};
	cursor: pointer;
	font-size: 15px;
	font-weight: 600;
	/* 44px keeps the only action on this page within the mobile touch-target minimum. */
	min-height: 44px;
	padding: 0 20px;

	&:disabled {
		cursor: default;
		opacity: 0.6;
	}
`;

export const Error = styled.p`
	color: ${({theme}) => theme.tokens.errorInk};
	font-size: 14px;
	margin: 16px 0 0;
`;

/**
 * The scope line. A tinted band rather than another paragraph because it is the reassurance the whole
 * marketing scope exists to deliver — "your receipts still arrive" must not read as fine print.
 */
export const Scope = styled.p`
	background: ${({theme}) => theme.tokens.signalTint};
	border-radius: 12px;
	color: ${({theme}) => theme.tokens.signalInk};
	font-size: 0.85rem;
	line-height: 1.55;
	margin: 1rem 0 1.25rem;
	padding: 0.75rem 1rem;
`;

/** Secondary route to the real preferences, which need a login. */
export const ManageLink = styled.a`
	color: ${({theme}) => theme.tokens.blue};
	display: inline-block;
	font-size: 0.8rem;
	margin-top: 0.75rem;
	text-decoration: underline;
	text-underline-offset: 2px;
`;
